import { useState, useEffect, useContext } from 'react';
// sections
import TableRow from './TableRow';
// components
import Breadcrumbs from '../../../components/breadcrumbs';
import TableInfo from '../../../components/table-info';
import Pagination from '../../../components/pagination';
import Dialog from '../../../components/dialog';
// @devextreme
import DataGrid, { Column } from 'devextreme-react/data-grid';
// styles
import { ThemeContext } from 'styled-components';
import { Container, SearchWrapper, Box, PrimaryButton, Status, SensorTable } from '../../../styles';
// apis
import { getStatusCount, getStatus } from '../../../apis';

// ----------------------------------------------------------------------

const sizes = [10, 20, 30];

// ----------------------------------------------------------------------

export default function StatusPage() {

  const theme = useContext(ThemeContext);

  const [ count, setCount ] = useState({ totalCount: 0, noSignalCount: 0, sensorErrorCount: 0, lowBatteryCount: 0 });
  const { totalCount: devices, noSignalCount: signal, sensorErrorCount: error, lowBatteryCount: battery } = count;
  
  const [ data, setData ] = useState({ content: [], totalElements: 0, totalPages: 1 });
  const { content: rows, totalElements: total, totalPages: pages } = data;

  const [ target, setTarget ] = useState('name');
  const [ keyword, setKeyword ] = useState('');

  const [ status, setStatus ] = useState('');

  const [ page, setPage ] = useState(0);
  const [ size, setSize ] = useState(20);

  const [ dialog, setDialog ] = useState(null);
  const handleClose = () => setDialog(null);

  useEffect(() => {
    ( async () =>
      await getStatusCount(setCount)
    )();
    ( async () =>
      await getStatus(setData, search(), status, page, size)
    )();
  }, [status]);
  
  const search = (reset?: boolean) => {
    if ( reset ) return { name: '', serial: '' };
    return {
      name: target === 'name' ? keyword : '',
      serial: target === 'serial' ? keyword : ''
    }
  };

  const handlePage = (value: number) => {
    setPage(value-1);
    getStatus(setData, search(), status, value-1, size);
  };

  const handleSize = (value: number) => {
    setPage(0);
    setSize(value);
    getStatus(setData, search(), status, 0, value);
  };

  const handleSearch = () => {
    if ( keyword.length > 0 && keyword.replace(/ /g, '').length === 0 ) return;
    setPage(0);
    getStatus(setData, search(), status, 0, size);
  };

  return (
    <Container>
      <Breadcrumbs
        heading='IoT 장비 현황'
        links={[
          {name: 'IoT 장비 관리'},
          {name: 'IoT 장비 현황'}
        ]}
      />

      <Status>
        <div>
          <button type='button' onClick={() => setStatus('')}>
            <div><div /><p>전체</p></div>
            <div>{ devices }</div>
          </button>
          <button type='button' onClick={() => setStatus('&noSignal=true')}>
            <div><div /><p>신호 없음</p></div>
            <div>{ signal }</div>
          </button>
        </div>
        <div>
          <button type='button' onClick={() => setStatus('&sensorError=true')}>
            <div><div /><p>센서 오류</p></div>
            <div>{ error }</div>
          </button>
          <button type='button' onClick={() => setStatus('&lowBattery=true')}>
            <div><div /><p>배터리 경고</p></div>
            <div>{ battery }</div>
          </button>
        </div>
      </Status>

      <SearchWrapper>
        <div>
          <select value={target} onChange={(event) => setTarget(event.target.value)}>
            <option value='name'>IoT 장비 그룹</option>
            <option value='serial'>일련 번호</option>
          </select>

          <input type='text' placeholder='검색어를 입력하세요.' onChange={(event) => setKeyword(event.target.value)} onKeyDown={(event) => { if(event.key === 'Enter') handleSearch() }} />
          <PrimaryButton type='button' onClick={() => handleSearch()}>검색</PrimaryButton>
        </div>

        <div />
      </SearchWrapper>
      
      <Box>
        <TableInfo total={total} pages={pages} page={page} sizes={sizes} size={size} handleSize={handleSize} />

        <DataGrid
          dataSource={rows}
          noDataText=''
          columnAutoWidth={true}
          paging={{enabled: false}}
          dataRowRender={({data}) => <TableRow row={data} theme={theme} setDialog={setDialog} />}
        >
          <Column caption='IoT 장비 그룹' dataField='iotGroupName' alignment='center' />
          <Column caption='설치 위치' dataField='location' alignment='center' />
          <Column caption='일련 번호' dataField='serialNumber' alignment='center' />
          <Column caption='수신 신호' dataField='noSignal' alignment='center' />
          <Column caption='수신 신호 감도' dataField='rsrp' alignment='center' />
          <Column caption='센서 오류' dataField='waterQualitySensorErrorCount' alignment='center' />
          <Column caption='배터리 (%)' dataField='batteryLevel' alignment='center' />
          <Column caption='장비 온도 (℃)' dataField='boardTemperature' alignment='center' />
          <Column caption='장비 상태' dataField='enabled' alignment='center' />
          <Column caption='측정 시간' dataField='acquisitionAt' alignment='center' />
        </DataGrid>

        <Pagination page={page} pages={pages} size={size} handlePage={handlePage} />
      </Box>

      { dialog &&
        <Dialog
          title='수질 센서 정보'
          handleClose={handleClose}
        >
          <SensorTable>
            <tbody>
              <tr>
                { dialog.map((item: any) => (
                  <td key={item.channel}>
                    <div>채널 { item.channel }</div>
                    <div className={ item.status === 'ERROR' ? 'error' : ''}>{ item.name }</div>
                  </td>
                ))}
              </tr>
            </tbody>
          </SensorTable>
          
          <PrimaryButton onClick={() => setDialog(false)} >
              확인
          </PrimaryButton>
        </Dialog>
      }
    </Container>
  );
}